import { DexieAdapter } from './dexie-adapter';

export const db = new DexieAdapter();

// Test/debug introspection hook — see ADR-042 §Layer 3 (Test introspection hook).
// Unconditional exposure; production users have no behavior change. Read-only
// access pattern: window.__RIDGEN__.db.<table>.<op>(). Do not add behavior
// gates under this namespace.
declare global {
  interface Window {
    __RIDGEN__?: { db: typeof db };
  }
}
if (typeof window !== 'undefined') {
  window.__RIDGEN__ = { db };
}
